<div class="column spacing-24 footer-container">
	<app-not-authorized-notice has="userRoleManagement"></app-not-authorized-notice>

	<div class="content-container" [appHasSystemCapability] has="userRoleManagement">
		<div class="content-container-header">
			<h3><b i18n="@@add-roleRoleName">Role Name</b></h3>
		</div>

		<mat-divider></mat-divider>

		<mat-form-field
			subscriptSizing="dynamic"
			appearance="outline"
			class="column"
			style="width: 350px; height: 47px; padding: 24px"
		>
			<mat-label i18n="@@add-roleName">Name</mat-label>
			<input matInput [(ngModel)]="editRole.name" data-automation-id="name-input" required />
		</mat-form-field>
	</div>

	<app-system-capability-table
		[roleName]="editRole.name"
		[companyId]="companyId"
		[companyType]="companyType"
		[systemCapabilityItems]="editRole.systemCapabilityItems"
		[showRoleName]="false"
		[mode]="mode"
		(systemCapabilitiesToggleEvents)="systemCapabilitiesToggleEvents($event)"
		[appHasSystemCapability]
		has="userRoleManagement"
	>
	</app-system-capability-table>
</div>
